{
  "boot": {
    "settings": "Loading Black Line",
    "session": "Signing you in",
    "page": "Building the page",
    "hero": "Preparing the arena"
  },
  "common": {
    "loading": "Loading…",
    "retry": "Retry",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "back": "Back",
    "confirm": "Confirm",
    "delete": "Delete",
    "rename": "Rename",
    "change": "Change",
    "buy": "Buy",
    "buying": "Buying…",
    "equip": "Equip",
    "equipped": "Equipped",
    "owned": "Owned",
    "locked": "Locked",
    "open": "Open",
    "view": "View",
    "claim": "Claim",
    "claiming": "Claiming…",
    "claimed": "Claimed",
    "remove": "Remove",
    "submit": "Submit",
    "download": "Download",
    "downloading": "Downloading…",
    "copyLink": "Copy link",
    "linkCopied": "Link copied.",
    "empty": "Nothing here yet.",
    "error": "Something went wrong.",
    "unavailable": "Unavailable",
    "comingSoon": "Coming soon",
    "credits": "Credits",
    "gems": "Gems",
    "level": "Level",
    "levelShort": "LVL",
    "rank": "Rank",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "language": "Language",
    "chooseLanguage": "Choose a language",
    "soundOn": "Sound on",
    "soundOff": "Sound off",
    "toggleSound": "Toggle sound",
    "soft": "SOFT",
    "premium": "PREMIUM",
    "unlockLevel": "Level {level}",
    "unlockPoints": "{points} RP",
    "unlockGems": "{gems} gems",
    "players": {
      "one": "{n} player",
      "other": "{n} players"
    },
    "rounds": {
      "one": "{n} round",
      "other": "{n} rounds"
    },
    "matches": {
      "one": "{n} match",
      "other": "{n} matches"
    },
    "items": {
      "one": "{n} item",
      "other": "{n} items"
    },
    "levelN": "Level {level}"
  },
  "nav": {
    "play": "Play",
    "loadout": "Loadout",
    "armoury": "Armoury",
    "shop": "Shop",
    "inventory": "Inventory",
    "career": "Career",
    "leaderboards": "Leaderboards",
    "quests": "Quests",
    "settings": "Settings",
    "more": "More",
    "community": "Community",
    "sections": "Sections",
    "modes": "Modes",
    "arsenal": "Arsenal",
    "maps": "Maps",
    "operators": "Operators",
    "netcode": "Netcode",
    "questions": "Questions",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "backToLobby": "Back to the lobby",
    "faq": "FAQ",
    "news": "News",
    "guide": "Guide",
    "explore": "Explore",
    "menu": "Menu",
    "backToMenu": "Back to menu",
    "lobby": "Lobby"
  },
  "auth": {
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "signInLede": "Sign in to continue.",
    "welcomeBack": "Welcome back",
    "createAccount": "Create account",
    "createAnAccount": "Create an account",
    "creating": "Creating…",
    "registerLede": "It takes less than a minute.",
    "email": "Email",
    "username": "Username",
    "password": "Password",
    "passwordMin": "Password (min 8 chars)",
    "newPassword": "New password",
    "newPasswordMin": "New password (min 8 chars)",
    "showPassword": "Show password",
    "forgotPassword": "Forgot password?",
    "resetPassword": "Reset password",
    "forgotLede": "Enter your email and we'll send a reset link.",
    "sendResetLink": "Send reset link",
    "sending": "Sending…",
    "setNewPassword": "Set new password",
    "chooseNewPassword": "Choose a new password",
    "resetRedirectNote": "You'll be redirected to sign in after reset.",
    "saving": "Saving…",
    "backToSignIn": "Back to sign in",
    "checkInbox": "Check your inbox and click the link to continue.",
    "verifyEmail": "Verify your email",
    "verifying": "Verifying email…",
    "verified": "Email verified. You can now sign in.",
    "waitForVerification": "Please wait for verification to complete.",
    "oneMoment": "One moment.",
    "emailTaken": "Email taken",
    "player": "PLAYER",
    "strapline": "60Hz servers · browser · no download",
    "backToHome": "Back to the home page",
    "consentBefore": "I agree to the ",
    "consentBetween": " and the ",
    "consentAfter": ".",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy"
  },
  "landing": {
    "hero": {
      "tagline": "Twelve rounds. One life each. Your browser.",
      "playFree": "Play free",
      "signIn": "Sign in"
    },
    "modes": {
      "title": "Pick how much you want to lose.",
      "lede": "Deathmatch to warm up. Competitive when it should count. Practice when nobody is online and you still want to shoot something.",
      "deathmatch": {
        "name": "Deathmatch",
        "figureLabel": "one round",
        "teams": "Teams",
        "teamsValue": "2 · up to 16 players",
        "death": "Death",
        "deathValue": "respawn in 3 s",
        "win": "Win",
        "winValue": "most kills at zero",
        "stakes": "Stakes",
        "stakesValue": "XP and levels"
      },
      "competitive": {
        "name": "Competitive",
        "figureLabel": "rounds · first to 7",
        "round": "Round",
        "roundValue": "2:00 · one life",
        "objective": "Objective",
        "objectiveValue": "plant or defuse",
        "halftime": "Halftime",
        "halftimeValue": "sides swap at 6",
        "stakes": "Stakes",
        "stakesValue": "rank points"
      },
      "practice": {
        "name": "Practice",
        "figureLabel": "you and nine bots",
        "rules": "Rules",
        "rulesValue": "deathmatch",
        "bots": "Bots",
        "botsValue": "miss like people",
        "queue": "Queue",
        "queueValue": "none — instant",
        "stakes": "Stakes",
        "stakesValue": "nothing"
      }
    },
    "arsenal": {
      "title": "{count} guns. Each owns a range.",
      "lede": "Every bar is the number the server resolves your shot with — damage inside the falloff, designed rate of fire, and how far the ray travels before it stops.",
      "damage": "Damage",
      "rate": "Rate",
      "range": "Range",
      "rpm": "{value} rpm",
      "metres": "{value} m",
      "magazine": "{rounds} rounds · {seconds}s reload"
    },
    "maps": {
      "title": "{count} maps, drawn from their own data.",
      "lede": "These are not paintings. Each plan is generated from the level geometry the server collides you against — the walls you see here are the walls that stop bullets.",
      "defaultRotation": "Default rotation",
      "competitive": "Competitive",
      "deathmatch": "Deathmatch",
      "aerialAlt": "{name} — aerial view",
      "footprint": "{width} × {depth} m · {spawns} spawns",
      "footprintSites": "{width} × {depth} m · {spawns} spawns · {sites} sites"
    },
    "operators": {
      "title": "{count} bodies. Earned, ranked or bought.",
      "lede": "Cosmetic only — a skin never changes a hitbox. What it changes is whether the killcam is embarrassing.",
      "unlock": {
        "owned": "Owned",
        "level": "Reach level {level} · or {gems} gems",
        "rank": "Earn {points} rank points · or {gems} gems",
        "purchase": "{gems} gems"
      }
    },
    "netcode": {
      "title": "Built like a shooter, shipped like a web page.",
      "lede": "Browser shooters usually cheat: the client decides who got hit, and the server takes its word. Black Line runs the match on a fixed sixty-hertz server that owns every consequence. Your client predicts your movement so it feels instant, and the server rewinds time to where you were aiming when you fired.",
      "simulationLabel": "Server simulation",
      "simulationNote": "Every input runs exactly one fixed step. No extrapolation, no guessing.",
      "snapshotsLabel": "World snapshots",
      "snapshotsNote": "Bit-packed deltas. Eight players cost 75 bytes a tick.",
      "rewindLabel": "Lag compensation",
      "rewindNote": "Shots are rewound to what you saw, capped so nobody hides in the past.",
      "inputLabel": "Input packet",
      "inputNote": "Your whole tick — buttons, look, sequence — in twelve bytes."
    },
    "faq": {
      "title": "Before you ask.",
      "seeAll": "See all questions",
      "lede": "Support edits these in the admin panel, so what you read here is what they would tell you today."
    },
    "closing": {
      "title": "Warmup is already running.",
      "lede": "No launcher, no patch night. An account takes under a minute and the first match starts on its own.",
      "createAccount": "Create an account",
      "haveOne": "I have one"
    },
    "footer": {
      "legal": "Legal",
      "contact": "Contact",
      "about": "Black Line is a browser-based multiplayer shooter.",
      "operatedBy": "{game} is operated by {parts}.",
      "registration": "Reg. {number}",
      "docFailed": "This document could not be loaded right now."
    }
  },
  "faq": {
    "lede": "Everything a new player asks, in the order the support desk put them. Nothing here needs an account to read.",
    "readGuide": "Read the guide",
    "stillStuck": "Still stuck? The guide covers the controls, the modes and how the netcode decides a shot.",
    "emptyTitle": "No questions published yet",
    "emptyBody": "The support desk has not posted anything here. The fastest answer is a match — the queue is open, an account takes under a minute, and Practice fills with bots the moment you join.",
    "offlineTitle": "The FAQ is offline",
    "offlineBody": "The support desk could not be reached. Reload in a moment — the game itself is unaffected."
  },
  "news": {
    "title": "News",
    "lede": "Patch notes, balance passes and new maps, newest first.",
    "readDispatch": "Read the dispatch →",
    "olderDispatches": "Older dispatches",
    "allDispatches": "← All dispatches",
    "backToNews": "Back to news",
    "neighbours": "Neighbouring dispatches",
    "newer": "← Newer",
    "older": "Older →",
    "emptyTitle": "No dispatches yet",
    "emptyBody": "Nothing has been posted to the board. The game is playable right now regardless — the queue is open and an account takes under a minute.",
    "offlineTitle": "The board is offline",
    "offlineBody": "The dispatch board could not be reached. Reload in a moment — the game itself is unaffected.",
    "goneTitle": "This dispatch is gone",
    "goneBody": "It was unpublished or the link is wrong. The rest of the board is still there.",
    "loadFailedTitle": "The dispatch could not be loaded"
  },
  "guide": {
    "title": "How to play",
    "lede": "Five minutes of reading and you are ahead of most of the lobby. Every figure below comes from the game itself, not from a brochure.",
    "onThisPage": "On this page",
    "tocLabel": "Guide sections",
    "sections": {
      "what": {
        "nav": "The game",
        "title": "What Black Line is"
      },
      "modes": {
        "nav": "Modes",
        "title": "The three modes"
      },
      "controls": {
        "nav": "Controls",
        "title": "Controls"
      },
      "progression": {
        "nav": "Progression",
        "title": "Loadouts, the armoury and credits"
      },
      "netcode": {
        "nav": "Netcode",
        "title": "How the netcode works"
      }
    },
    "what": {
      "p1": "Black Line is a multiplayer first-person shooter that runs in a browser tab. There is no launcher, no download and no patch night: you open the page, the match server hands you a seat, and warmup is already running.",
      "p2": "Every shot is hitscan — the bullet arrives the moment you fire, and where it lands is decided by the server, not your machine. Rounds are short, teams are up to {players} players, and a death costs you three seconds in deathmatch and the rest of the round in competitive.",
      "p3": "The arsenal is {guns} guns and {throwables} throwables. You start with an assault rifle, a revolver and a frag grenade, which is a complete loadout — nothing on the unlock ladder is stronger than what you already hold, only different."
    },
    "modes": {
      "intro": "Every mode runs on the same simulation and the same maps. What changes is what a death costs you and what a win is worth.",
      "practiceNote": "Practice is the one to open first: it fills with bots, it never queues, and nothing you do in it counts."
    },
    "controls": {
      "intro": "Click the arena once to hand the mouse to the game; Esc gives it back. On a phone or a tablet the touch layout mounts instead — the same movement model, quantised to the same eight directions the wire carries, so nobody gets an analog advantage.",
      "absolute": "One rule is worth repeating: weapon select is absolute. Holding 2 asks for the sidearm on every tick it is held, so a dropped packet costs you nothing. There is no next-weapon key on purpose.",
      "keyboardCaption": "Keyboard and mouse",
      "touchCaption": "Touch",
      "keyboard": {
        "move": "Move. Hold Shift to sprint, and the crouch key while moving to slide.",
        "look": "Look and aim. The crosshair is where the shot goes — nothing auto-aims.",
        "fire": "Fire. Automatic weapons keep firing while held; bloom grows while you hold it.",
        "ads": "Aim down sights. Tighter spread, slower movement.",
        "slots": "Primary, sidearm, utility. Absolute — a key always selects that slot, never the next one.",
        "reload": "Reload. Interruptible: switching weapons cancels it.",
        "jump": "Jump. Into a ledge at speed it becomes a vault.",
        "crouch": "Crouch. A crouched body is a shorter target, and the hitbox matches what you see.",
        "scoreboard": "Scoreboard.",
        "pause": "Release the mouse and open the pause menu."
      },
      "touch": {
        "stick": {
          "keys": "Left 45%",
          "action": "Move stick. Drag from anywhere in that band; the stick appears where your thumb lands."
        },
        "look": {
          "keys": "Right side",
          "action": "Drag to look. Same sensitivity model as the mouse, tuned for a thumb."
        },
        "fire": {
          "keys": "FIRE / ADS",
          "action": "Held buttons inside the safe area, sized to the 44px minimum."
        },
        "jump": {
          "keys": "JUMP / CROUCH",
          "action": "Tap. Crouch is a toggle so a thumb is not pinned down."
        },
        "reload": {
          "keys": "RELOAD",
          "action": "Tap. The weapon rows on the HUD are tappable too — that is how you switch slots."
        },
        "landscape": {
          "keys": "Landscape",
          "action": "The arena is landscape only; portrait shows a rotate prompt rather than a squeezed HUD."
        }
      }
    },
    "progression": {
      "p1": "A loadout is {slots} slots: a primary, a sidearm and a utility. You get {free} loadouts for free and build each one yourself from what you own.",
      "p2": "Matches pay experience and credits. Levelling grants a weapon outright — the first unlock lands at level {firstLevel}, and the ladder runs to level {lastLevel}. There is nothing to buy: reach the level and the weapon is already yours to equip.",
      "p3": "Skins are cosmetic and stay cosmetic: {operators} operators, some earned by level or rank, all of them buyable. In a match your team is read from a red or blue outline, never from the colour of your kit — so a skin never costs you a read.",
      "step1": "Play a match. Practice counts for nothing, so queue Deathmatch when you want the credits.",
      "step2": "Open Loadout and equip the weapon you just unlocked — nothing to buy, it was granted at the level.",
      "step3": "Open Loadout and put it in a slot. The change applies to your next match, not the one you are in.",
      "step4": "Spend on skins last. They change nothing about how you shoot."
    },
    "netcode": {
      "p1": "Your browser predicts what it can and the server decides what happened. Movement, the weapon state machine and a grenade's arc all run from the same code on both sides, so the game feels immediate on a bad line; where a shot landed is never predicted, because a client that chose its own outcome would always choose the flattering one.",
      "p2": "When a shot arrives the server rewinds every target to where you saw it, capped so nobody can hide in the past. That is why a hit that looked like a hit registers as one, and why a player standing behind a wall on your screen is not shootable however far behind they are."
    }
  },
  "shell": {
    "getGems": "Get Gems",
    "openShop": "Open the Shop",
    "openShopGems": "Open the Shop — buy gems",
    "openCareer": "Open Career — your level and stats",
    "signOutTitle": "Sign out of your account",
    "dailyReward": "Daily reward",
    "dailyReady": "Day {day} is ready",
    "collected": "Collected",
    "recentMatches": "Recent matches",
    "primary": "Primary",
    "store": "STORE",
    "daily": {
      "day": "Day {day}",
      "todayWithItem": "Day {day}: {credits} credits and {item}.",
      "today": "Day {day}: {credits} credits.",
      "collectedToday": "Day {day} collected — the next one unlocks tomorrow.",
      "claimedWithItem": "+{credits} credits and {item}.",
      "claimedCredits": "+{credits} credits.",
      "claimFailed": "Could not claim — {message}",
      "modalTitle": "Daily reward · streak day {day} of 7",
      "ready": "Day {day} — ready",
      "readyAria": "Daily reward, day {day} ready to collect"
    }
  },
  "play": {
    "title": "Play",
    "mode": "Match mode",
    "modeChange": "Change mode",
    "deathmatch": "Deathmatch",
    "teamDeathmatch": "Team Deathmatch",
    "competitive": "Competitive",
    "practiceDeathmatch": "Practice — 5v5",
    "practiceBomb": "Practice — Bomb",
    "changeSkin": "Change skin",
    "community": "Community",
    "communitySoon": "Community hub — coming soon",
    "findingMatch": "Finding a match…",
    "playingNow": {
      "one": "{n} playing now",
      "other": "{n} playing now"
    },
    "queue": {
      "searching": "Searching for match",
      "found": "Match found",
      "accept": "Accept",
      "accepted": "Accepted",
      "decline": "Decline",
      "cancel": "Cancel",
      "starting": "Starting…",
      "slotsFilled": "{filled} / {total} players",
      "levelShort": "LV {level}"
    },
    "dossier": {
      "title": "Operative Dossier",
      "operator": "Operator",
      "tier": "Tier:",
      "unranked": "Unranked",
      "accuracy": "Accuracy",
      "kd": "K/D ratio",
      "winRate": "Win rate",
      "xpToNext": "XP to next level"
    },
    "modes": {
      "competitiveNote": "5v5 · 12 rounds · one life a round · rank points",
      "deathmatchNote": "everyone for themselves · 10 minutes · respawn",
      "teamDeathmatchNote": "10 minutes · respawn",
      "practiceDeathmatchNote": "solo + 9 bots · deathmatch vs bots, respawn on death · no XP or rank points",
      "practiceBombNote": "solo + 9 bots · 12 rounds, one life each · plant and defuse · no XP or rank points"
    },
    "communitySoonAria": "Community — coming soon",
    "modeAria": "{mode} — {count} playing",
    "status": {
      "noTicket": "joining without a ticket — {message}",
      "cancelled": "search cancelled",
      "declined": "someone declined — search ended",
      "expired": "accept window expired — search ended",
      "cooldown": "matchmaking cooldown after declining — wait a minute and try again",
      "error": "matchmaking error — try again",
      "offline": "matchmaking is offline — try again in a moment"
    },
    "xpProgress": "{xp} / {max} XP",
    "toLevel": "to level {level}",
    "season": {
      "ending": "ending",
      "lastDay": "last day",
      "daysLeft": "{days}d left",
      "line": "S{number} · {name} · {points} RP"
    },
    "loading": {
      "engine": "Starting engine",
      "connect": "Connecting to server",
      "weapons": "Loading weapons",
      "characters": "Loading characters",
      "map": "Building map",
      "client": "Downloading game",
      "entering": "Entering match",
      "ready": "Ready"
    }
  },
  "loadout": {
    "title": "Loadout",
    "primary": "Primary",
    "sidearm": "Sidearm",
    "utility": "Utility",
    "finish": "Finish",
    "stockFinish": "Stock finish",
    "stock": "Stock",
    "active": "Active",
    "newLoadout": "New loadout",
    "buySlot": "Buy another loadout slot",
    "deleteLoadout": "Delete loadout",
    "deleteThis": "Delete this loadout",
    "lastCannotDelete": "Your last loadout cannot be deleted",
    "tapToEquip": "Tap to equip",
    "weaponStats": "Weapon statistics",
    "automatic": "Automatic",
    "scoped": "Scoped",
    "unavailable": "loadout unavailable — {message}",
    "tabs": {
      "weapons": "Weapons",
      "operator": "Operator",
      "cosmetics": "Cosmetics"
    },
    "cosmetics": {
      "charm": "Weapon charm",
      "spray": "Spray",
      "emote": "Callout",
      "card": "Player card",
      "title": "Title",
      "none": "None",
      "worn": "Worn",
      "empty": "Nothing here yet — buy one in the Marketplace."
    }
  },
  "armoury": {
    "title": "Armoury",
    "worn": "Worn",
    "notEnoughGems": "Not enough gems",
    "reachLevel": "Reach level {level}",
    "rank": "Rank",
    "unavailable": "armoury unavailable — {message}"
  },
  "shop": {
    "title": "Shop",
    "getGems": "Get Gems",
    "balance": "Balance",
    "bestValue": "Best value",
    "starter": "Starter",
    "earn": "Earn",
    "needGems": "Need gems",
    "testMode": "Test mode — no real charge.",
    "packagesFailed": "Could not load gem packages.",
    "noPackages": "No gem packages are available right now.",
    "purchaseFailed": "Purchase failed — try again.",
    "previewDisabled": "Purchases are disabled on this preview.",
    "skinsNote": "Locked skins unlock from play, not credits. Equip anything you own in the Armoury.",
    "soldOut": "Every purchasable operator is yours. New stock arrives with the season.",
    "titles": {
      "title": "Titles",
      "note": "Worn next to your name on Career. Cheaper than a skin, and there are ten.",
      "wear": "Wear",
      "worn": "Worn",
      "notEnoughCredits": "Not enough credits",
      "failedDetail": "failed — {message}"
    },
    "equipInArmoury": "equip in Loadout",
    "skinsNoteAll": "Every skin is for sale in gems; level and rank skins also unlock from play. Equip anything you own in the Armoury.",
    "orRequirement": "· or {requirement}",
    "gemsAdded": "+{gems} gems",
    "purchaseFailedDetail": "purchase failed — {message}",
    "custom": {
      "title": "Custom amount",
      "hint": "Any amount from {min} to {max} gems, in steps of 100."
    },
    "paymentProcessing": "Confirming your payment…",
    "paymentFailed": "Payment could not be confirmed. If you were charged, contact support with the time of purchase.",
    "paymentCancelled": "Payment cancelled — nothing was charged.",
    "paymentUnknown": "No payment session found.",
    "needCredits": "Need credits",
    "weaponSkins": {
      "title": "Weapon Finishes",
      "note": "One flat finish per weapon, 900 gems each. Owned finishes equip from the Armoury."
    },
    "charms": {
      "title": "Charms",
      "note": "A charm hangs off every weapon you carry — one worn at a time, across your whole loadout.",
      "worn": "Worn"
    },
    "playerCards": {
      "title": "Player Cards",
      "note": "A frame and badge behind your name — on the in-match scoreboard, Leaderboards, your Career page, the Loadout screen and the header. Cosmetic only.",
      "worn": "Worn"
    },
    "tabs": {
      "all": "All",
      "operators": "Operators",
      "sell": "Sell",
      "gems": "Get Gems"
    },
    "viewAll": "View all",
    "market": {
      "empty": "Nothing here yet — check back with a new season.",
      "worn": "Worn"
    },
    "sprays": {
      "title": "Sprays"
    },
    "emotes": {
      "title": "Emotes",
      "preview": "Preview {item}"
    },
    "sell": {
      "note": "Everything you have bought, with what it pays back. The sale returns a share of what THAT purchase cost you — from your own ledger, never the current price — and always in the currency you paid."
    },
    "nameRequired": {
      "title": "Your name for the payment",
      "body": "The payment provider needs your real first and last name. We save it to your profile (Settings → Identity).",
      "save": "Save and continue",
      "missing": "Enter both your first and last name.",
      "saveFailed": "Could not save your name — try again."
    }
  },
  "inventory": {
    "title": "Inventory",
    "locker": "Locker",
    "all": "All",
    "skins": "Skins",
    "weapons": "Weapons",
    "finishes": "Finishes",
    "titles": "Titles",
    "other": "Other items",
    "slots": "Slots",
    "skin": "Skin",
    "weapon": "Weapon",
    "finish": "Finish",
    "titleItem": "Title",
    "purchased": "Purchased",
    "standardIssue": "Standard issue",
    "setInLoadout": "Set in Loadout",
    "emptyLocker": "Nothing owned yet — the Shop and the Armoury are where that changes.",
    "unreachable": "The locker is unreachable right now.",
    "noneOwned": "No {kind} owned yet.",
    "sell": {
      "action": "Sell back",
      "actionAria": "Sell {item} back",
      "confirmTitle": "Sell back",
      "confirmBody": "Sell {item} back? You keep half of what you paid, and the item is gone for good.",
      "confirmOk": "Sell back",
      "paidLabel": "You paid",
      "payoutLabel": "You'll get back",
      "refusedGranted": "This was granted, not bought — there is nothing to refund.",
      "refusedAlreadySold": "This has already been sold back.",
      "refusedNotOwned": "You do not own this any more.",
      "refusedNotSellable": "This cannot be sold back.",
      "refusedGeneric": "Could not sell this back. Try again in a moment.",
      "empty": "You have bought nothing yet. Anything you buy shows up here with what it would pay back.",
      "selectAll": "Select all",
      "sortPayout": "Highest payout",
      "sortPaid": "Highest price paid",
      "sortName": "Name",
      "sortKind": "Category",
      "feeLabel": "Sell-back fee ({rate}%)",
      "sellSelected": "Sell {count} selected",
      "bulkBody": "Sell {count} items back? They are gone for good.",
      "partial": "{sold} sold, {failed} refused."
    }
  },
  "career": {
    "title": "Career",
    "stats": "Stats",
    "kills": "Kills",
    "deaths": "Deaths",
    "headshots": "Headshots",
    "headshotRate": "Headshot rate",
    "accuracy": "Accuracy",
    "kd": "K/D ratio",
    "wins": "Wins",
    "winRate": "Win rate",
    "gamesPlayed": "Games played",
    "xpToNext": "XP to next level",
    "rank": "Rank",
    "equippedCharacter": "Equipped character",
    "matchHistory": "Match history",
    "win": "Win",
    "loss": "Loss",
    "week": "WEEK",
    "goToPlay": "Go to Play",
    "emptyStats": "Nothing on the board yet. Every figure here starts moving the moment you finish your first match.",
    "emptyHistory": "Nothing recent yet — your last few matches will show up here.",
    "allTime": "{label} · all-time",
    "rankPoints": "{points} rank points",
    "medalsTab": "Medals {unlocked}/{total}",
    "loadoutNamed": "Loadout — {name}"
  },
  "leaderboards": {
    "title": "Leaderboards",
    "kills": "Kills",
    "wins": "Wins",
    "headshots": "Headshots",
    "rank": "Rank",
    "you": "You",
    "goToPlay": "Go to Play",
    "openSlot": "Open",
    "emptyBoard": "Nobody has posted {label} yet. Finish a match and the first name on this board is yours.",
    "yourRank": "Your {label} rank",
    "rankOf": "#{rank} of {total}",
    "topN": "Top {count}",
    "noEntries": "no entries",
    "rankedCount": "{count} ranked",
    "gapToNext": "{amount} to #{rank}",
    "podiumLabel": "Top three"
  },
  "quests": {
    "title": "Quests",
    "daily": "Daily",
    "weekly": "Weekly",
    "active": "ACTIVE",
    "completed": "COMPLETED",
    "claimedTag": "CLAIMED",
    "inProgress": "In progress",
    "readyToClaim": "Ready to claim",
    "dailyReset": "Daily reset",
    "creditsOnOffer": "Credits on offer",
    "reward": "Reward:",
    "claimFailed": "Could not claim this reward — try again.",
    "emptyTitle": "No quests today",
    "emptyBody": "Quests are assigned daily and weekly. Play a match and this board fills itself.",
    "weeklyIn": "weekly in {hours}h",
    "progressAria": "{name} progress"
  },
  "settings": {
    "title": "Settings",
    "tabs": {
      "profile": "Profile",
      "account": "Account",
      "game": "Game",
      "controls": "Controls",
      "identity": "Identity",
      "papers": "Papers",
      "support": "Support",
      "about": "About"
    },
    "profile": {
      "username": "Username",
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "fullName": "Full name",
      "phone": "Phone",
      "dateOfBirth": "Date of birth",
      "country": "Country",
      "address": "Address",
      "memberSince": "Member since",
      "selectCountry": "Select country",
      "saveDetails": "Save details",
      "detailsSaved": "Details saved.",
      "detailsFailed": "Could not save details.",
      "nothingChanged": "Nothing changed.",
      "editingDisabled": "Profile editing is not available on this server yet.",
      "invalidPhone": "Invalid phone number",
      "verified": "Verified",
      "unverified": "Unverified",
      "resendVerification": "Resend verification email",
      "sent": "Sent",
      "sendFailed": "Could not send — try again."
    },
    "password": {
      "change": "Change password",
      "current": "Current password",
      "new": "New password",
      "confirm": "Confirm new password",
      "changed": "Password changed.",
      "failed": "Could not change password.",
      "mismatch": "Passwords do not match.",
      "tooShort": "New password must be at least 8 characters."
    },
    "game": {
      "postProcessing": "Post-processing",
      "postNote": "Bloom and grading. Turn off first when frames are short.",
      "ambientOcclusion": "Ambient occlusion",
      "aoNote": "Ambient occlusion — contact shadows in corners. AUTO is on for mouse and keyboard, off on touch.",
      "masterVolume": "Master volume",
      "menuMusic": "Menu music",
      "mouseSensitivity": "Mouse sensitivity",
      "netcodeDiagnostics": "Netcode diagnostics",
      "resetDefaults": "Reset to defaults",
      "appliesNextMatch": "Applies at the next match start.",
      "deviceNote": "Stored on this device and applied when a match starts. Nothing here changes gameplay.",
      "auto": "AUTO",
      "off": "OFF",
      "none": "NONE",
      "on": "ON",
      "menuMusicNote": "The menu's ambient bed. Master volume scales it; this kills it.",
      "languageNote": "Remembered on this device.",
      "volumeNote": "The in-match M key mutes on top of this."
    },
    "controls": {
      "rebindNote": "Fixed for now — rebinding is not built yet.",
      "sprint": "Sprint",
      "crouch": "Crouch — hold while sprinting to slide",
      "jump": "Jump — into a ledge to vault",
      "reload": "Reload",
      "ads": "Aim down sights",
      "pickUp": "Pick up a dropped weapon",
      "scoreboard": "Scoreboard",
      "weaponSlots": "Primary · sidearm · utility",
      "shift": "Shift",
      "ctrlC": "Ctrl / C",
      "space": "Space",
      "tab": "Tab",
      "rightMouse": "Right mouse",
      "spray": "Leave a spray",
      "emote": "Radio callout",
      "inspect": "Inspect your weapon"
    },
    "billing": {
      "address": "Billing address",
      "country": "Billing country",
      "save": "Save country",
      "saved": "Billing country saved.",
      "failed": "Could not save country.",
      "pickFirst": "Pick a country first.",
      "note": "Your billing country sets the VAT rate on your invoices. It is separate from identity verification below."
    },
    "identity": {
      "title": "Identity verification",
      "document": "Document",
      "fillEveryField": "Fill in every field and attach a document.",
      "submitted": "Submitted — under review.",
      "submitFailed": "Could not submit.",
      "empty": "Identity verification and legal documents will show up here once they are published.",
      "status": {
        "pending": "PENDING",
        "approved": "APPROVED",
        "rejected": "REJECTED",
        "none": "NONE"
      },
      "submittedOn": "Submitted {date}"
    },
    "invoices": {
      "title": "Invoices",
      "empty": "No invoices yet",
      "emptyBody": "Invoices for gem purchases will appear here once you top up.",
      "previewDisabled": "Invoices are disabled on this preview.",
      "loadFailed": "Could not load invoices.",
      "downloadFailed": "Download failed — try again.",
      "notFound": "Not found",
      "status": {
        "paid": "PAID",
        "pending": "PENDING",
        "cancelled": "CANCELLED",
        "failed": "FAILED",
        "void": "VOID",
        "completed": "COMPLETED"
      }
    },
    "wallet": {
      "purchases": "Purchases",
      "transactions": "Transactions",
      "noPurchases": "No purchases yet",
      "noTransactions": "No transactions yet",
      "purchasesBody": "Gem purchases will show up here once you top up.",
      "transactionsBody": "Purchases, rewards and matches will show up here as they happen.",
      "openShop": "Open the shop",
      "balance": "Balance",
      "withdrawable": "Available to withdraw",
      "withdrawableNote": "This is your deposits minus what you've already withdrawn — a return of unspent deposit, never more than you put in. Wins and bonuses grow your balance but never raise this cap.",
      "withdrawTitle": "Withdraw",
      "amount": "Amount (EUR)",
      "payoutMethodLabel": "Payout method",
      "payoutMethod": {
        "card": "Card",
        "iban": "Bank transfer (IBAN)",
        "bank_transfer": "Bank transfer"
      },
      "destination": "Account details",
      "destinationHint": "IBAN, card token, or transfer reference — whatever your payout method needs.",
      "destinationRequired": "Enter your account details.",
      "fee": "Fee",
      "netAmount": "You will receive",
      "invalidAmount": "Enter an amount to withdraw.",
      "submit": "Request withdrawal",
      "submitting": "Requesting…",
      "pendingTitle": "Withdrawal pending review",
      "pendingAmount": "Requested",
      "pendingFee": "Fee",
      "pendingNet": "You will receive",
      "pendingStatus": "Status",
      "pendingSince": "Requested {date}",
      "error": {
        "WITHDRAWALS_DISABLED": "Withdrawals are not available right now.",
        "KYC_REQUIRED": "Verify your identity before withdrawing.",
        "kycLink": "Go to Papers",
        "PENDING_WITHDRAWAL": "You already have a withdrawal request awaiting review.",
        "BELOW_MINIMUM": "The minimum withdrawal is {amount}.",
        "EXCEEDS_CAP": "You can only withdraw up to {amount} — your available balance.",
        "INSUFFICIENT_GEMS": "You can only withdraw deposits you have not spent — you no longer hold enough of the gems they bought.",
        "generic": "Could not submit the withdrawal."
      }
    },
    "referral": {
      "title": "Referral",
      "invitePlayer": "Invite a player",
      "yourLink": "Your link",
      "code": "Code",
      "claimInvite": "Claim your invite",
      "claimBonus": "Claim bonus",
      "signedUpThroughYou": "Signed up through you",
      "claimFailed": "Could not claim this code.",
      "alreadyClaimed": "You have already claimed an invite bonus — one per account.",
      "selectedHint": "Selected — copy it with your keyboard.",
      "share": "Send this to someone who has never played. When they sign up through it, they get {reward} Credits.",
      "claimedReward": "Claimed — {reward} Credits added.",
      "arrivedWith": "You arrived with the code {code}."
    },
    "legal": {
      "title": "Legal",
      "company": "Company",
      "registration": "Registration",
      "jurisdiction": "Jurisdiction",
      "docFailed": "Could not load this document."
    },
    "signOutNote": "Signs this device out.",
    "emptyTitle": "Nothing here yet",
    "about": {
      "signedInAs": "Signed in as {name} · {email}",
      "version": "Black Line · version {version}",
      "adminPanel": "Admin panel"
    },
    "table": {
      "date": "Date",
      "description": "Description",
      "amount": "Amount",
      "balance": "Balance",
      "package": "Package",
      "price": "Price",
      "status": "Status",
      "number": "Number",
      "gems": "Gems"
    }
  },
  "placeholder": {
    "coming": "Coming in Sprint 05 · Batch 2",
    "backedBy": "Backed by: {what}"
  },
  "confirmDialog": {
    "ok": "Confirm",
    "buyTitle": "Confirm purchase",
    "buyBody": "Buy {item} for {price}?",
    "equipTitle": "Equip",
    "equipBody": "Equip {item}?",
    "replaces": "Replaces {current}.",
    "topupTitle": "Top up",
    "topupBody": "Buy {gems} gems for {price}?",
    "switchTitle": "Switch",
    "switchBody": "Switch to {item}?",
    "balanceAfter": "Balance after: {balance}",
    "wearTitle": "Wear title",
    "wearBody": "Wear {item} next to your name?"
  }
}
